import * as React from 'react';
import * as styles from '../view-segment.module.scss';
import { SegmentAttributeOperator, SegmentDetailParsedAttributeGroup } from '../../../models/segments';
import ViewAttribute from './view-attribute';
import clsx from 'clsx';
import { findBaseAttributeId } from '../../../utilities/attribute-filter';

interface Props {
  attributeGroup: SegmentDetailParsedAttributeGroup;
  /** nesting depth */
  depth: number;
}

const ViewAttributeGroup = ({ attributeGroup, depth }: Props) => {
  return (
    <React.Fragment>
      <ul className={clsx(styles.attributeGroup, depth > 0 && styles.deeplyNested)}>
        {attributeGroup.predicates.map((predicate, idx) => (
          <React.Fragment key={`${findBaseAttributeId(predicate)}-${idx}`}>
            {idx > 0 && ('predicates' in predicate || depth === 0) && (
              <li className={styles.operator}>{SegmentAttributeOperator[attributeGroup.operator]}</li>
            )}
            {'attributeId' in predicate ? (
              <ViewAttribute
                attribute={predicate}
                depth={depth}
                inlineOperator={idx > 0 && depth > 0 ? attributeGroup.operator : undefined}
              />
            ) : (
              <ViewAttributeGroup attributeGroup={predicate} depth={depth + 1} />
            )}
          </React.Fragment>
        ))}
      </ul>
    </React.Fragment>
  );
};

export default ViewAttributeGroup;
